import {
  SET_REMOVE_WALLET,
  SET_RENAME_WALLET,
  SET_GOOGLE_DRIVE_KEYSTORES,
  SET_SELECTED_WALLET,
} from './action'

const initialState = {
  toBeRemovedWallet: null,
  toBeRenamedWallet: null,
  keystores: null,
  selectedWallet: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_REMOVE_WALLET:
      return {
        ...state,
        toBeRemovedWallet: action.data,
      }

    case SET_RENAME_WALLET:
      return {
        ...state,
        toBeRenamedWallet: action.data,
      }

    case SET_GOOGLE_DRIVE_KEYSTORES:
      return {
        ...state,
        keystores: action.data,
      }

    case SET_SELECTED_WALLET:
      return {
        ...state,
        selectedWallet: action.data,
      }

    default:
      return state
  }
}
